export const mfaModals = {
  ACTIVATION: 'mfa-activate',
  DEACTIVATION: 'mfa-deactivate',
  MODAL: 'mfa-modal'
};

export const mfaExpressions = {
  ACTIVATE_WITH_SUCCESS: 'patient.mfa-activate.success',
  DEACTIVATION_WITH_SUCCESS: 'patient.mfa-deactivation.success',
  EXPIRED_INVALID_CODE: 'tws.mfa.expired-or-invalid-code',
  SYSTEM_INTERNAL_ERROR: 'newaccount.error.internal.server.error.try.again',
};
